<template>
    <div class="emp-card" :key="`emp-${employeeId}`">

        <div class="mb-3">
            <DxButton class="edit-icon-btn" @click="openEdit">
                <i class="edit-icon"></i>
            </DxButton>
        </div>
        <div class="emp-card__header">
            <div class="emp-card__subtitle">
                {{ employee?.Employee.Name || '—' }} {{ employee?.Employee.Surname || '' }}
            </div>
        </div>

        <div class="emp-form-wrapper">
            <DxAccordion class="emp-acc" :data-source="sections" :multiple="false" :animation-enabled="true"
                :defer-rendering="false" :focus-state-enabled="false">
                <template #title="{ data }">
                    <div class="emp-acc__title">
                        <span class="emp-acc__title-text">{{ data.title }}</span>
                        <span class="emp-acc__chev" aria-hidden="true"></span>
                    </div>
                </template>

                <template #item="{ data }">
                    <div class="emp-acc__panel">
                        <DxForm :label-location="'top'" :col-count="2" :col-count-by-screen="{ xs: 1, sm: 2, md: 2 }"
                            :min-col-width="220" :styling-mode="'filled'" class="emp-form" :form-data="employee">


                            <template v-if="data.key === 'ident'">
                                <DxSimpleItem data-field="Employee.InternalCode" :label="{ text: 'Cod intern' }"
                                    :editor-options="{ readOnly: !isEditing }" />

                                <DxSimpleItem data-field="Employee.Cnp" :label="{ text: 'CNP' }"
                                    :editor-options="{ readOnly: !isEditing }" />

                                <DxSimpleItem data-field="Sex" :label="{ text: 'Sex' }"
                                    :editor-options="{ readOnly: !isEditing }" />

                                <DxSimpleItem data-field="Employee.BornDate" :label="{ text: 'Data Nașterii' }"
                                    editor-type="dxDateBox" :editor-options="{
                                        type: 'date',
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: !isEditing
                                    }" />

                                <DxSimpleItem data-field="Struct" :label="{ text: 'Departament' }" :col-span="2"
                                    :editor-options="{
                                        readOnly: !isEditing
                                    }" />
                                <DxSimpleItem data-field="EmpGroup" :label="{ text: 'Grup Angajati' }" :editor-options="{
                                    readOnly: !isEditing
                                }" :col-span="2" />


                            </template>

                            <template v-else-if="data.key === 'idcard'">

                                <DxSimpleItem data-field="DocIdentTip" :label="{ text: 'Tip Act Identitate' }"
                                    :editor-options="{
                                        readOnly: !isEditing,
                                    }" />
                                <DxSimpleItem data-field="Employee.DocIdentSerie" :label="{ text: 'Serie' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.DocIdentNo" :label="{ text: 'Numar' }"
                                    :editor-options="{ readOnly: !isEditing }" />

                                <DxSimpleItem data-field="Employee.DocIdentIssueDate" editor-type="dxDateBox"
                                    :label="{ text: 'Data Emiterii' }"
                                    :editor-options="{ readOnly: !isEditing, displayFormat: 'dd MMM yyyy' }" />
                                <DxSimpleItem data-field="Employee.DocIdentIssuer" :label="{ text: 'Emitent' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.DocIdentExpiryDate" editor-type="dxDateBox"
                                    :label="{ text: 'Data Expirare' }"
                                    :editor-options="{ readOnly: !isEditing, displayFormat: 'dd MMM yyyy' }" />
                                <DxSimpleItem data-field="Localitate" :label="{ text: 'Loc Naștere' }" :editor-options="{
                                    readOnly: !isEditing,
                                }" />
                                <DxSimpleItem data-field="Tara" :label="{ text: 'Țara Naștere' }" :editor-options="{
                                    readOnly: !isEditing,
                                }" />

                                <DxSimpleItem data-field="Adresa" :label="{ text: 'Adresa Domiciliu' }" :editor-options="{
                                    readOnly: !isEditing,
                                }" :col-span="2" />

                            </template>



                            <template v-else-if="data.key === 'diverse'">
                                <DxSimpleItem data-field="Meserie" :label="{ text: 'Meserie/Profesie*' }"
                                    :editor-options="{
                                        readOnly: !isEditing,

                                    }" />
                                <DxSimpleItem data-field="Employee.NrCrtOrg" :label="{ text: 'Nr. Crt. Organigrama' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Functie" :label="{ text: 'Functie (Post)' }" :editor-options="{
                                    readOnly: !isEditing,
                                }" />
                                <DxSimpleItem data-field="GrupaMunca" :label="{ text: 'Grupa de Munca' }"
                                    :editor-options="{
                                        readOnly: !isEditing,
                                    }" />
                                <DxSimpleItem data-field="Employee.FunctieDeBaza" editor-type="dxSwitch"
                                    :label="{ text: 'Funcție de bază' }" :editor-options="{ readOnly: !isEditing }" />

                                <DxSimpleItem data-field="Employee.Pensionar" :label="{ text: 'Este Pensionar? ' }"
                                    :editor-options="{ readOnly: !isEditing }" editor-type="dxSwitch" />
                                <DxSimpleItem data-field="Employee.OreContract" :label="{ text: 'Ore Contract' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.ZileConc" :label="{ text: 'Zile Concediu' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="StudiesLevel" :label="{ text: 'Nivel Studii' }"
                                    :editor-options="{
                                        readOnly: !isEditing,
                                    }" />
                                <DxSimpleItem data-field="MrtStatus" :label="{ text: 'Stare Civila' }" :editor-options="{
                                    readOnly: !isEditing,

                                }" />
                                <DxSimpleItem data-field="DrvLicense" :label="{ text: 'Permis Auto' }" :editor-options="{
                                    readOnly: !isEditing,

                                }" />
                                <DxSimpleItem data-field="Employee.Vechime" :label="{ text: 'Vechime Calculat' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.Observations" :label="{ text: 'Observatii' }"
                                    :editor-options="{ readOnly: !isEditing }" :col-span="2" />

                            </template>

                            <template v-else-if="data.key === 'revisal'">
                                <DxSimpleItem data-field="Employee.TransferInRevisal" editor-type="dxSwitch"
                                    :label="{ text: 'Transfer In Revisal' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.Apatrid" :label="{ text: 'Apatrid' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Nationalitate" :label="{ text: 'Nationalitate' }"
                                    :editor-options="{
                                        readOnly: !isEditing,
                                    }" />
                                <DxSimpleItem data-field="Employee.Mentiuni" :label="{ text: 'Mentiuni' }"
                                    :editor-options="{ readOnly: !isEditing }" />

                            </template>

                            <template v-else-if="data.key === 'salariatStrain'">
                                <DxSimpleItem data-field="Employee.TipAutorizatie" :label="{ text: 'Tip Autorizatie' }"
                                    :col-span="2" :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :label="{ text: 'Data Inceput Autorizatie' }" editor-type="dxDateBox"
                                    :editor-options="{
                                        type: 'date',
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: isReadonlyTipAuorizatie,
                                    }" />
                                <DxSimpleItem data-field="Employee.DataSfarsitAutorizatie"
                                    :label="{ text: 'Data Sfarsit Autorizatie' }" editor-type="dxDateBox"
                                    :editor-options="{
                                        type: 'date',
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: isReadonlyTipAuorizatie,

                                    }" />

                            </template>

                            <template v-else-if="data.key === 'd112'">
                                <DxSimpleItem data-field="Employee.CasaSn" :label="{ text: 'Casa Asigurari Sanatate' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="TipAsigurat" :label="{ text: 'Tip Asigurat(A, B)' }"
                                    :editor-options="{
                                        readOnly: !isEditing,

                                    }" />
                                <DxSimpleItem data-field="AsigScu" :editor-options="{
                                    readOnly: !isEditing,

                                }" :label="{ text: 'Scutire plata impozit pe venit: tip persoana' }" :col-span="2" />
                                <DxSimpleItem data-field="Employee.D112AsigCi"
                                    :editor-options="{ readOnly: !isEditing }" editor-type="dxSwitch"
                                    :label="{ text: 'Asigurat pentru concedii si indemnizatii de asigurari sociale de sanatate' }"
                                    :col-span="2" />
                                <DxSimpleItem data-field="Employee.D112AsigSo"
                                    :editor-options="{ readOnly: !isEditing }" editor-type="dxSwitch"
                                    :label="{ text: 'Asigurat in sistemul de asigurari pt somaj' }" />

                                <DxSimpleItem data-field="Employee.D112AsigExc"
                                    :editor-options="{ readOnly: !isEditing }" editor-type="dxSwitch"
                                    :label="{ text: 'Persoana exceptatat de la plata CAS si CASS' }" />
                            </template>

                            <template v-else-if="data.key === 'card'">
                                <DxSimpleItem data-field="Employee.CardSalary" :label="{ text: 'Are Card?' }"
                                    :editor-options="{ readOnly: !isEditing }" editor-type="dxSwitch" />
                                <DxSimpleItem data-field="Employee.CardNo" :label="{ text: 'Numar' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.CardAccNo" :label="{ text: 'Cont' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Banca" :label="{ text: 'Banca' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                            </template>

                            <template v-else-if="data.key === 'pontaj'">

                                <DxSimpleItem data-field="Employee.PontajOraInceput"
                                    :label="{ text: 'Oră început program' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.PontajPauzaMinute"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: 'Durată pauză de masă (minute)' }" />
                                <DxSimpleItem data-field="Structura" :label="{ text: 'Vizibil pentru: ' }"
                                    :editor-options="{ readOnly: !isEditing }" :col-span="2" />
                                <DxSimpleItem data-field="Employee.PontajUsrId" editor-type="dxTextBox"
                                    :label="{ text: 'User ID - Sistem Pontaj' }" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }" />
                            </template>

                            <template v-else-if="data.key === 'CategorieBaza'">
                                <DxSimpleItem data-field="Employee.SalBaza" :label="{ text: 'Salariu de baza' }"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: 'Somer unic sustinator fam. monoparentala' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: 'Somer peste 45 ani ' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }" :label="{ text: 'Avans suma fixa ' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: 'Primeste bonuri de masa' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }" :label="{ text: 'Suma Spor Weekend' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: 'Calcul Contributii CAS, CASS la Sal Min' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: 'Motiv exceptare CAS, CASS Sal Min' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }" :col-span="2"
                                    :label="{ text: 'Numar copii inscrisi invatamant(OG.16/2022-art.77.10b)-deducere supl.' }" />

                            </template>

                            <template v-else-if="data.key === 'CategorieSomaj'">
                                <DxSimpleItem data-field="salBaza" :label="{ text: 'Conventie Grupare' }" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: 'Conventie Somaj Data ' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :editor-options="{ readOnly: !isEditing }" :col-span="2"
                                    :label="{ text: 'Conventie Somaj Nr ' }" />

                            </template>

                            <template v-else-if="data.key === 'CategorieVenituri'">
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.0 Alte drepturi neimpozitabile, cf.art.76 alin.(4) din CF (necategorisite mai jos)****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.1 Indemnizatii de delegare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF***' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.2 Indemnizatii de detasare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.3 Indemnizatii specifice detasarii transnationale neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.4 Prestatii suplimentare primite de salariati in baza clauzei de mobilitate neimpozabile, cf.art.76 alin.(2) si alin.(4) lit.a) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.5 Avantajele sub forma dreptului la stock options plan, la momentul acordarii si la momentul exercitarii acestora, cf.art.76 alin.(4) lit.r) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.6 Contributiile la un fond de pensii facultative(L.204/2006), suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76alin.(4^1) lit.e) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.7 Primele de asigurare voluntara de sanatate precum si serviciile medicale furnizate sub forma de abonament, suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76 alin.(4^1) lit.f) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.8 C/val serv. turistice si/sau de tratament (+transportul), pe perioada CO, acordate de angajator pentru salariatii proprii, cf. CIM sau in regulamentul intern, cf.art.76 alin.(4^1) lit.d) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.9 C/val ab. pentru utilizarea facilitatilor sportive, suportate de angajator, in limita a 400 euro/an/persoana, cf.art. 76 alin. 4^1 lit. h) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.10 C/val hranei acordate de catre angajator pentru angajatii proprii, cf. art. 76 alin. 4^1 lit. b) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.11 Cazarea si contravaloarea chiriei pentru spatiile de cazare/de locuit puse de catre angajatori la dispozitia angajatilor propriii, cf. art.76 alin. 4^1 lit. c) din CF	****' }" />
                                <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                    :editor-options="{ readOnly: !isEditing }"
                                    :label="{ text: ' 8.4.12 Sumele acordate angajatilor care desfasoara activitati in regim de telemunca, cf. art. 76 alin.4^1 lit. g) din CF		****' }" />

                            </template>
                        </DxForm>
                    </div>
                </template>
            </DxAccordion>

            <DxPopup :visible="popupVisible" :show-title="true" :drag-enabled="true" :close-on-outside-click="false"
                :width="800" :height="620">
                <template #title>
                    <div style="background-color: #ff2c21;
               font-size: 15px;
               color: white;
               font-weight: bold;
               padding: 10px;
               padding-left: 20px;">
                        Editare - {{ employee?.Employee.Name || '—' }} {{ employee?.Employee.Surname || '' }}
                    </div>
                </template>

                <div class="p-3">
                    <div v-if="errorText" class="alert alert-danger mb-3">{{ errorText }}</div>

                    <DxForm ref="editFormRef" :form-data="employee" styling-mode="filled" :read-only="isSaving">

                        <DxTabbedItem :tab-panel-options="tabPanelOptions" css-class="tabs-two-rows">
                            <DxTab :title="tabs[0]">
                                <DxGroupItem :col-count="3">
                                    <DxSimpleItem data-field="Employee.InternalCode" :label="{ text: 'Cod intern' }"
                                        :is-required="true" />
                                    <DxSimpleItem data-field="Employee.Name" :label="{ text: 'Nume' }"
                                        :is-required="true" />
                                    <DxSimpleItem data-field="Employee.Surname" :label="{ text: 'Prenume' }"
                                        :is-required="true" />

                                    <DxSimpleItem data-field="Employee.Cnp" :label="{ text: 'CNP' }" :is-required="true"
                                        editor-type="dxTextBox" :editor-options="{
                                            mask: '0000000000000',
                                            useMaskedValue: true,
                                            onValueChanged: onCnpChanged
                                        }" />
                                    <DxSimpleItem data-field="Employee.Sex" :label="{ text: 'Sex' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.Sex ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        }" :is-required="true" />

                                    <DxSimpleItem data-field="Employee.BornDate" editor-type="dxDateBox"
                                        :is-required="true" :label="{ text: 'Data Nașterii' }"
                                        :editor-options="{ type: 'date', displayFormat: 'dd MMM yyyy' }" />
                                    <DxSimpleItem data-field="Employee.EmpgroupId" :label="{ text: 'Grup Angajati' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.GrupaAngajati ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                        }" :is-required="true" />

                                    <DxSimpleItem data-field="Employee.StructId" :label="{ text: 'Departament' }"
                                        :col-span="2" editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsStructuri,
                                            valueExpr: 'ID',
                                            displayExpr: 'Name',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',

                                        }" :is-required="true" />
                                </DxGroupItem>
                            </DxTab>

                            <DxTab :title="tabs[1]">
                                <DxGroupItem :col-count="3">
                                    <DxSimpleItem data-field="Employee.DocIdentTip"
                                        :label="{ text: 'Tip Act Identitate' }" editor-type="dxSelectBox"
                                        :editor-options="{
                                            dataSource: dsGetAll?.DocIdentTip ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Carte Identitate'
                                        }" />
                                    <DxSimpleItem data-field="Employee.DocIdentSerie" :label="{ text: 'Serie' }" />
                                    <DxSimpleItem data-field="Employee.DocIdentNo" :label="{ text: 'Numar' }"
                                        editor-type="dxTextBox" :editor-options="{
                                            mask: '000000',
                                            useMaskedValue: true,

                                        }" />
                                    <DxSimpleItem data-field="Employee.DocIdentIssuer" :label="{ text: 'Emitent' }" />


                                    <DxSimpleItem data-field="Employee.DocIdentIssueDate" editor-type="dxDateBox"
                                        :label="{ text: 'Data Emiterii' }" :editor-options="{
                                            displayFormat: 'dd MMM yyyy',
                                            onValueChanged(e) {
                                                employee.Employee.DocIdentIssueDate = e.value;
                                            }
                                        }" />

                                    <DxSimpleItem data-field="Employee.DocIdentExpiryDate" editor-type="dxDateBox"
                                        :label="{ text: 'Data Expirare' }" :editor-options="{
                                            displayFormat: 'dd MMM yyyy',
                                            min: expiryMinDate
                                        }" />
                                    <DxSimpleItem data-field="Employee.BornCntryId" :label="{ text: 'Țara' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.Tari ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',

                                        }" />

                                    <DxSimpleItem :label="{ text: 'Localitate' }" editor-type="dxSelectBox"
                                        :editor-options="{
                                            dataSource: dsLocalitati ?? [],
                                            valueExpr: 'ID',
                                            displayExpr(item) { return item ? `${item.CodSiruta}/Jud. ${item.Judet}/ ${item.Localitate}/ ${item.Sat}` : `` },
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                            value: employee.Employee.BornPlaceId,

                                            onValueChanged: (e) => {
                                                employee.Employee.BornPlaceId = e.value;
                                            },

                                        }" :col-span="2" />

                                    <DxSimpleItem :col-span="3" :label="{ text: 'Adresa Domiciliu' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsAdrese,
                                            valueExpr: 'ID',
                                            displayExpr: 'Adresa1',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',

                                            value: employee.Employee.AddressId,

                                            onValueChanged: (e) => {
                                                employee.Employee.AddressId = e.value;
                                            },

                                            onOpened: (e) => {
                                                e.component.close();
                                                popupAdreseVisible = true;
                                                openAddressPopup();
                                            }
                                        }" />
                                </DxGroupItem>
                            </DxTab>

                            <DxTab :title="tabs[2]">
                                <DxGroupItem :col-count="3">
                                    <DxSimpleItem :label="{ text: 'Meserie/Profesie*' }" editor-type="dxSelectBox"
                                        :editor-options="{
                                            dataSource: dsMeserii ?? [],
                                            valueExpr: 'ID',
                                            displayExpr(item) { return item ? `${item.code}/${item.name}` : `` },
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                            value: employee.Employee.MeserieId,

                                            onValueChanged: (e) => {
                                                employee.Employee.MeserieId = e.value;
                                            },
                                        }" />
                                    <DxSimpleItem data-field="Employee.NrCrtOrg"
                                        :label="{ text: 'Nr. Crt. Organigrama' }" />
                                    <DxSimpleItem data-field="Employee.PositionId" :label="{ text: 'Funcție (Post)' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.Post ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'name',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }" />
                                    <DxSimpleItem data-field="Employee.WorkGrade" :label="{ text: 'Grupa de Muncă' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.WorkGrade ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }" />
                                    <DxSimpleItem data-field="Employee.FunctieDeBaza" editor-type="dxSwitch"
                                        :label="{ text: 'Funcție de bază' }" />
                                    <DxSimpleItem data-field="Employee.Pensionar" :label="{ text: 'Este Pensionar? ' }"
                                        editor-type="dxSwitch" />
                                    <DxSimpleItem data-field="Employee.OreContract" :label="{ text: 'Ore Contract' }" />
                                    <DxSimpleItem data-field="Employee.ZileConc" :label="{ text: 'Zile Concediu' }" />
                                    <DxSimpleItem data-field="Employee.StudiesLevel" :label="{ text: 'Nivel Studii' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.StudiesLevel ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }" />
                                    <DxSimpleItem data-field="Employee.MrtStatus" :label="{ text: 'Stare Civila' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.Mrt ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        }" />
                                    <DxSimpleItem data-field="Employee.DrvLicense" :label="{ text: 'Permis Auto' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.DrvLicense ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        }" />
                                    <DxSimpleItem data-field="Employee.Vechime" :label="{ text: 'Vechime Calculat' }" />
                                    <DxSimpleItem data-field="Employee.Observations" :label="{ text: 'Observatii' }"
                                        :col-span="3" />
                                </DxGroupItem>
                            </DxTab>

                            <DxTab :title="tabs[3]">
                                <DxGroupItem :col-count="2">

                                    <DxSimpleItem data-field="Employee.TransferInRevisal" editor-type="dxSwitch"
                                        :label="{ text: 'Transfer In Revisal' }" />
                                    <DxSimpleItem data-field="Employee.Apatrid" editor-type="dxSelectBox"
                                        :editor-options="{
                                            dataSource: dsGetAll?.Apatrid ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,

                                        }" />
                                    <DxSimpleItem :label="{ text: 'Nationalitate' }" editor-type="dxSelectBox"
                                        :editor-options="{
                                            dataSource: dsNationalitati ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                            value: employee.Employee.TaraNationalitateId,

                                            onValueChanged: (e) => {
                                                employee.Employee.TaraNationalitateId = e.value;
                                            },
                                        }" />

                                    <DxSimpleItem data-field="Employee.Mentiuni" :label="{ text: 'Mentiuni' }" />
                                </DxGroupItem>
                            </DxTab>
                            <DxTab :title="tabs[4]" :disabled="detaliiStrainDisabled">
                                <DxGroupItem :col-count="2">
                                    <DxSimpleItem data-field="Employee.TipAutorizatie"
                                        :label="{ text: 'Tip Autorizatie' }" :col-span="2" editor-type="dxSelectBox"
                                        :editor-options="{
                                            dataSource: dsGetAll?.TipAutorizatie ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" editor-type="dxDateBox"
                                        :label="{ text: 'Data Inceput Autorizatie' }" :editor-options="{
                                            displayFormat: 'dd MMM yyyy',

                                            onValueChanged(e) {
                                                employee.Employee.DataInceputAutorizatie = e.value;
                                            }
                                        }" />

                                    <DxSimpleItem data-field="Employee.DataSfarsitAutorizatie" editor-type="dxDateBox"
                                        :label="{ text: 'Data Sfarsit Autorizatie' }" :editor-options="{
                                            displayFormat: 'dd MMM yyyy',
                                            min: expiryDate,

                                        }" />
                                </DxGroupItem>
                            </DxTab>
                            <DxTab :title="tabs[5]">
                                <DxGroupItem :col-count="2">
                                    <DxSimpleItem data-field="Employee.CasaSn"
                                        :label="{ text: 'Casa Asigurari Sanatate' }" editor-type="dxSelectBox"
                                        :editor-options="{
                                            dataSource: dsGetAll?.CasaSn ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,


                                        }" />
                                    <DxSimpleItem data-field="D112TipAsigurat" :label="{ text: 'Tip Asigurat(A, B)' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.D112_TipAsigurat ?? [],
                                            valueExpr: 'cod',
                                            displayExpr: 'nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            onValueChanged(e) {
                                                employee.Employee.D112TipAsigurat = e.value;
                                            }

                                        }" />
                                    <DxSimpleItem data-field="D112AsigScu" editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.D112_AsigScu ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        onValueChanged(e) {
                                            employee.Employee.D112AsigScu = e.value;
                                        }

                                    }" :label="{ text: 'Scutire plata impozit pe venit: tip persoana' }"
                                        :col-span="2" />
                                    <DxSimpleItem data-field="Employee.D112AsigCi" editor-type="dxSwitch"
                                        :label="{ text: 'Asigurat pentru concedii si indemnizatii de asigurari sociale de sanatate' }"
                                        :col-span="2" />
                                    <DxSimpleItem data-field="Employee.D112AsigSo" editor-type="dxSwitch"
                                        :label="{ text: 'Asigurat in sistemul de asigurari pt somaj' }" />

                                    <DxSimpleItem data-field="Employee.D112AsigExc" editor-type="dxSwitch"
                                        :label="{ text: 'Persoana exceptatat de la plata CAS si CASS' }" />
                                </DxGroupItem>
                            </DxTab>
                            <DxTab :title="tabs[6]">
                                <DxGroupItem :col-count="2">

                                    <DxSimpleItem data-field="Employee.CardSalary" :label="{ text: 'Are Card?' }"
                                        editor-type="dxSwitch" />
                                    <DxSimpleItem data-field="Employee.CardNo" :label="{ text: 'Numar' }"
                                        :editor-options="{
                                            mask: '0000000000000000',
                                            useMaskedValue: true,
                                            readOnly: isReadonly
                                        }" />
                                    <DxSimpleItem data-field="Employee.CardBankId" :label="{ text: 'Banca' }"
                                        editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.Banca ?? [],
                                            valueExpr: 'ID',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează'
                                        }" />
                                    <DxSimpleItem data-field="Employee.CardAccNo" :label="{ text: 'Cont' }" />

                                </DxGroupItem>
                            </DxTab>
                            <DxTab :title="tabs[7]">
                                <DxGroupItem :col-count="3">
                                    <DxSimpleItem data-field="Employee.PontajOraInceput"
                                        :label="{ text: 'Oră început program' }" />
                                    <DxSimpleItem data-field="Employee.PontajPauzaMinute"
                                        :label="{ text: 'Durată pauză de masă (minute)' }" />
                                    <DxSimpleItem data-field="Employee.StructuraId"
                                        :label="{ text: 'Vizibil pentru: ' }" editor-type="dxSelectBox" :editor-options="{
                                            dataSource: dsGetAll?.Structura ?? [],
                                            valueExpr: 'Id',
                                            displayExpr: 'Nume',
                                            showClearButton: true,
                                            searchEnabled: true,
                                            placeholder: 'Selectează',
                                        }" />
                                    <DxSimpleItem data-field="Employee.PontajUsrId" editor-type="dxTextBox"
                                        :label="{ text: 'User ID - Sistem Pontaj' }" :col-span="3" />

                                </DxGroupItem>
                            </DxTab>
                            <DxTab :title="tabs[8]">
                                <DxGroupItem :col-count="2">
                                    <DxSimpleItem data-field="Employee.SalBaza" :label="{ text: 'Salariu de baza' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                        :label="{ text: 'Somer unic sustinator fam. monoparentala' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                        :label="{ text: 'Somer peste 45 ani ' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                        :label="{ text: 'Avans suma fixa ' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                        :label="{ text: 'Primeste bonuri de masa' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                        :label="{ text: 'Suma Spor Weekend' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                        :label="{ text: 'Calcul Contributii CAS, CASS la Sal Min' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie"
                                        :label="{ text: 'Motiv exceptare CAS, CASS Sal Min' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: 'Numar copii inscrisi invatamant(OG.16/2022-art.77.10b)-deducere supl.' }" />

                                </DxGroupItem>
                            </DxTab>
                            <DxTab :title="tabs[9]">
                                <DxGroupItem :col-count="1">
                                    <DxSimpleItem data-field="salBaza" :label="{ text: 'Conventie Grupare' }"
                                        :col-span="2" />
                                    <DxSimpleItem data-field="DataInceputAutorizatie"
                                        :label="{ text: 'Conventie Somaj Data ' }" />
                                    <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: 'Conventie Somaj Nr ' }" />
                                </DxGroupItem>
                            </DxTab>
                            <DxTab :title="tabs[10]">
                                <DxGroupItem :col-count="1">
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.0 Alte drepturi neimpozitabile, cf.art.76 alin.(4) din CF (necategorisite mai jos)****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.1 Indemnizatii de delegare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF***' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.2 Indemnizatii de detasare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.3 Indemnizatii specifice detasarii transnationale neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.4 Prestatii suplimentare primite de salariati in baza clauzei de mobilitate neimpozabile, cf.art.76 alin.(2) si alin.(4) lit.a) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.5 Avantajele sub forma dreptului la stock options plan, la momentul acordarii si la momentul exercitarii acestora, cf.art.76 alin.(4) lit.r) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.6 Contributiile la un fond de pensii facultative(L.204/2006), suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76alin.(4^1) lit.e) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.7 Primele de asigurare voluntara de sanatate precum si serviciile medicale furnizate sub forma de abonament, suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76 alin.(4^1) lit.f) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.8 C/val serv. turistice si/sau de tratament (+transportul), pe perioada CO, acordate de angajator pentru salariatii proprii, cf. CIM sau in regulamentul intern, cf.art.76 alin.(4^1) lit.d) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.9 C/val ab. pentru utilizarea facilitatilor sportive, suportate de angajator, in limita a 400 euro/an/persoana, cf.art. 76 alin. 4^1 lit. h) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.10 C/val hranei acordate de catre angajator pentru angajatii proprii, cf. art. 76 alin. 4^1 lit. b) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.11 Cazarea si contravaloarea chiriei pentru spatiile de cazare/de locuit puse de catre angajatori la dispozitia angajatilor propriii, cf. art.76 alin. 4^1 lit. c) din CF	****' }" />
                                    <DxSimpleItem data-field="Employee.DataInceputAutorizatie" :col-span="2"
                                        :label="{ text: ' 8.4.12 Sumele acordate angajatilor care desfasoara activitati in regim de telemunca, cf. art. 76 alin.4^1 lit. g) din CF		****' }" />
                                </DxGroupItem>
                            </DxTab>
                        </DxTabbedItem>


                    </DxForm>
                </div>

                <DxToolbarItem toolbar="bottom" location="after" :widget="'dxButton'" :options="{
                    text: 'Salvează',
                    type: 'success',
                    stylingMode: 'contained',
                    onClick: submitForm,
                    width: 110,
                    height: 32,
                    elementAttr: { class: 'mb-2' }
                }" />

                <DxToolbarItem toolbar="bottom" location="after" :widget="'dxButton'" :options="{
                    text: 'Închide',
                    type: 'danger',
                    stylingMode: 'contained',
                    onClick: closePopup,
                    width: 110,
                    height: 32,
                    elementAttr: { class: 'mb-2' }
                }" />
            </DxPopup>

            <DxPopup :visible="popupAdreseVisible" :show-title="true" title="Selectare adresa" :width="840"
                :height="680" @hiding="popupAdreseVisible = false">
                <template #title>
                    <div
                        style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                        Selectează adresa
                    </div>
                </template>
                <div style="padding: 15px">

                    <div style="margin-bottom: 20px;">
                        <h4
                            style="font-weight: 800; margin-bottom: 10px; border-bottom: 2px solid #ff2c21; padding-bottom: 6px; color: #ff2c21;">
                            Adresa
                        </h4>

                        <DxSelectBox :data-source="dsGetAll?.TipAdresa" display-expr="nume" value-expr="cod"
                            placeholder="Tip" :search-enabled="true" v-model:value="dataAdress.TipCod" />

                        <div style="display: flex; gap: 10px; margin-top: 10px;">
                            <DxTextBox placeholder="Strada" style="margin-top: 10px; flex: 2;"
                                v-model:value="dataAdress.Strada" />

                            <DxTextBox placeholder="StradaNr" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.StradaNr" />

                            <DxTextBox placeholder="Bloc" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.Bloc" />

                            <DxTextBox placeholder="Scara" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.Scara" />

                            <DxTextBox placeholder="Etaj" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.Etaj" />

                            <DxTextBox placeholder="Apartament" style="margin-top: 10px; flex: 2;"
                                v-model:value="dataAdress.Apartament" />

                            <DxTextBox placeholder="CodPostal" style="margin-top: 10px; flex: 2;"
                                v-model:value="dataAdress.CodPostal" />
                        </div>

                        <div style="display: flex; gap: 10px; margin-top: 10px;">
                            <DxSelectBox :data-source="dsTari" display-expr="Nume" value-expr="ID" placeholder="Țara"
                                :search-enabled="true" v-model:value="dataAdress.TaraID"
                                @value-changed="onTaraChanged" />

                            <DxSelectBox :data-source="dsJudete" display-expr="Nume" value-expr="ID" placeholder="Județ"
                                :search-enabled="true" v-model:value="dataAdress.JudetID"
                                @value-changed="onJudetChanged" :disabled="!dataAdress.TaraID" />

                            <DxSelectBox :data-source="dsLocalitati" display-expr="Localitate" value-expr="ID"
                                placeholder="Localitate" :search-enabled="true" v-model:value="localitateId"
                                @value-changed="onLocalitateChanged" :disabled="!dataAdress.JudetID" />

                            <DxSelectBox :data-source="dsLocalitati" display-expr="Sat" value-expr="ID"
                                placeholder="Sat" :search-enabled="true" v-model:value="satId"
                                @value-changed="onSatChanged" :disabled="!localitateId" />
                        </div>
                        <DxTextBox placeholder="Cod SIRUTA" style="margin-top: 10px" :value="codSiruta"
                            :read-only="true" />
                    </div>
                    <div style="margin-bottom: 20px;">
                        <h4
                            style="font-weight: 800; margin-bottom: 10px; border-bottom: 2px solid #ff2c21; padding-bottom: 6px; color: #ff2c21;">
                            Profesional
                        </h4>
                        <DxTextBox placeholder="Telefon" v-model:value="dataAdress.Telefon" :show-spin-buttons="false"
                            :show-clear-button="true" :min="0" :format="'#0'" />

                        <DxTextBox placeholder="Email (acces Portal HR)" style="margin-top: 10px"
                            v-model:value="dataAdress.Email" />
                    </div>
                    <div style="margin-bottom: 20px;">
                        <h4
                            style="font-weight: 800; margin-bottom: 10px; border-bottom: 2px solid #ff2c21; padding-bottom: 6px; color: #ff2c21;">
                            Personal
                        </h4>
                        <DxTextBox placeholder="Telefon" v-model:value="dataAdress.TelefonPersonal"
                            :show-spin-buttons="false" :show-clear-button="true" :min="0" :format="'#0'" />
                        <DxTextBox placeholder="Email" style="margin-top: 10px"
                            v-model:value="dataAdress.EmailPersonal" />
                    </div>
                    <div style="text-align: right; margin-top: 15px;">
                        <DxButton text="Aplică" type="default"
                            style="height: 32px; font-size: 13px; padding: 2px 10px; width:110px; margin-right: 10px;"
                            @click="applyAddress" />

                        <DxButton text="Închide" type="danger"
                            style="height: 32px; font-size: 13px; padding: 2px 10px; width:110px;"
                            @click="closePopupAdrese" />
                    </div>

                </div>
            </DxPopup>
        </div>
    </div>
</template>

<script lang="ts">
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxButton from 'devextreme-vue/button';
import { defineComponent } from 'vue'
import { DxAccordion } from 'devextreme-vue/accordion'
import { DxForm, DxSimpleItem, DxGroupItem, DxTabbedItem, DxTab } from 'devextreme-vue/form'
import PER_Employees from '@/services/PER/PER_Employees'
import ToolbarForm from '@/components/utils/toolbar-form.vue';
import PER_ActiveEmployees from '@/services/PER/PER_ActiveEmployees';
import notify from 'devextreme/ui/notify';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import DxSelectBox from 'devextreme-vue/select-box';
import { DxTextBox } from 'devextreme-vue';

export default defineComponent({
    components: { DxAccordion, DxForm, DxSimpleItem, ToolbarForm, DxButton, DxPopup, DxToolbarItem, DxGroupItem, DxTabbedItem, DxTab, DxSelectBox, DxTextBox },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    data() {
        return {
            popupAdreseVisible: false,
            isCnpValid: false,
            dsLocalitati: {} as DataSource,
            dsJudete: {} as DataSource,
            dsMeserii: {} as DataSource,
            dsNationalitati: {} as DataSource,
            dsTari: {} as DataSource,
            dsAdrese: {} as DataSource,
            nationalitateRomaniaId: '0a2ed359-3731-47a2-855b-9ee58b1cbc32',
            dataAdress: {
                LocalitateID: null,
                JudetID: null,
                Telefon: null,
                Email: null,
                TaraID: null,
                LocalitateCodSiruta: null,
                TipCod: null,
                Strada: '',
                StradaNr: '',
                Bloc: '',
                Scara: '',
                Etaj: '',
                Apartament: '',
                CodPostal: '',
                PartenerID: null,       // îl setezi când deschizi popup-ul
                EmailPersonal: null,
                TelefonPersonal: null
            },
            employee: {
                Employee: {
                    Id: '',
                    OldId: null,
                    Name: '',
                    Surname: '',
                    Descr: null,
                    BornCntryId: null,
                    BornPlace: null,
                    BornDate: "",
                    Cnp: '',
                    InternalCode: '',
                    DocIdentSerie: '',
                    DocIdentNo: null,
                    DocIdentIssuer: null,
                    DocIdentIssueDate: null,
                    Sex: '',
                    MrtStatus: null,
                    Handicap: null,
                    CardSalary: false,
                    CardAccNo: null,
                    CardNo: null,
                    DrvLicense: null,
                    StudiesLevel: null,
                    Vechime: null,
                    SalBaza: '',
                    OreContract: null,
                    WorkGrade: '',
                    AddressId: '',
                    PositionId: '',
                    ProbationDate: null,
                    ProbationPeriod: null,
                    Student: null,
                    StudentYear: null,
                    EmpgroupId: '',
                    ZileConc: '',
                    StructId: '',
                    MeserieId: '',
                    Sters: null,
                    PontajSchemaId: null,
                    CardBankId: null,
                    IsSindicat: null,
                    SporConditii: null,
                    NaturaAngajat: null,
                    SporPermanent: null,
                    DataModificare: null,
                    BornPlaceId: null,
                    Foto: null,
                    CasaSn: '',
                    DataExpiraContract: null,
                    Pensionar: false,
                    FunctieDeBaza: false,
                    DataStartVechime: null,
                    Apatrid: null,
                    CnpVechi: null,
                    DetaliiSalariatStrain: null,
                    Mentiuni: null,
                    DocIdentTip: null,
                    TaraNationalitateId: null,
                    TipAutorizatie: null,
                    DataInceputAutorizatie: null,
                    DataSfarsitAutorizatie: null,
                    TransferInRevisal: null,
                    UserCreareRevisal: null,
                    DataCreareRevisal: null,
                    UserModificareRevisal: null,
                    DataModificareRevisal: null,
                    DocIdentExpiryDate: null,
                    DataStartVechimeFirma: null,
                    StructuraId: '',
                    AccesCardId: null,
                    Observations: null,
                    NrCrtOrg: null,
                    PontajUsrId: null,
                    Foto2: null,
                    D112AsigCi: false,
                    D112AsigSo: true,
                    D112AsigScu: "",
                    D112AsigExc: false,
                    PontajOraInceput: '',
                    PontajPauzaMinute: '',
                    TipAsigurat: '',
                    SemnaturaImg: null,
                    Localitate: '',
                    EmpGroup: '',
                    D112TipAsigurat: ''
                }
            },
            tabs: [
                "Identificare",
                "Act Identitate",
                "Diverse",
                "Revisal",
                "Detalii Străin",
                "D112",
                "Card",
                "Pontaj",
                "Categorie: Bază",
                "Categorie: Șomaj",
                "Venituri neimpozitabile"
            ],
            selectedTab: 0,
            dsGetAll: {
                Sex: [],
                DocIdentTip: [],
                Mrt: [],
                DrvLicense: [],
                WorkGrade: [],
                StudiesLevel: [],
                D112_TipAsigurat: [],
                D112_AsigScu: [],
                loc: [],
                tari: [],
                adrese: [],
                meserii: [],
                functie: [],
                nationalitati: [],
                structura: [],
                TipAutorizatie: [],
                TipAdresa: [],
                Apatrid: [],
                CasaSn: [],
                GrupaAngajati: [],
                Tari: [],
                Localitati: [],
                Adrese: [],
                Meserii: [],
                Post: [],
                Banca: [],
                Structura: []
            },
            taraId: null,
            judetId: null,
            localitateId: null,
            codSiruta: null,
            satId: null,
            popupVisible: false,
            isSaving: false,
            editModel: null,
            errorText: "",
            isEditing: false,
            employeeOriginalIdent: null,
            dsStructuri: [],
            sections: [
                { key: 'ident', title: 'Identificare' },
                { key: 'idcard', title: 'Act Identitate' },
                { key: 'diverse', title: 'Diverse' },
                { key: 'revisal', title: 'Revisal' },
                { key: 'salariatStrain', title: 'Detalii Salariat Strain' },
                { key: 'd112', title: 'D112' },
                { key: 'card', title: 'Card' },
                { key: 'pontaj', title: 'Pontaj' },
                { key: 'CategorieBaza', title: 'Categorie: Baza' },
                { key: 'CategorieSomaj', title: 'Categorie: Somaj' },
                { key: 'CategorieVenituri', title: 'Categorie: Venituri Neimpozitabile' }

            ],

        }
    },
    watch: {
        employeeId: {
            immediate: true,
            handler(newId: string) {
                if (newId) this.getAngajatiByID(newId)
            }
        }
    },
    mounted() {
        this.getDepartamente();
        this.getLookup(this.employeeId);
        this.getAll();
        this.dsTari = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + 'ERP_Tari',
                key: 'ID',
                keyType: 'Guid',
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    };
                }
            },
            sort: [{ selector: 'Nume', desc: false }]

        });
        this.dsLocalitati = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + 'ERP_Localitati',
                key: 'ID',
                keyType: 'Guid',
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    };
                }
            }
        });
        this.dsAdrese = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `ERP_Adrese`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
        this.dsJudete = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + 'ERP_Judete',
                key: 'ID',
                keyType: 'Guid',
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    };
                }
            }

        });
        this.dsMeserii = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `PER_Meserii`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
            sort: [{ selector: 'name', desc: false }]
        })
        this.dsNationalitati = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `RU_RVS_Nationalitati`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })

    },
    computed: {
        tabPanelOptions(): Record<string, unknown> {
            return {
                selectedIndex: this.selectedTab,
                deferRendering: true,
                animationEnabled: false,
                onSelectionChanged: (e: any) => {
                    this.selectedTab = e.component.option("selectedIndex");
                }
            };
        },
        expiryMinDate() {
            return this.employee.Employee.DocIdentIssueDate || null;

        },
        expiryDate() {
            return this.employee.Employee.DataInceputAutorizatie || null;
        },
        detaliiStrainDisabled() {

            return !this.employee.Employee.TaraNationalitateId
                || this.employee.Employee.TaraNationalitateId === this.nationalitateRomaniaId;
        },

        isReadonly() {
            return !this.employee.Employee.CardSalary;
        },
        isReadonlyTipAuorizatie() {
            return !this.employee.Employee.TipAutorizatie;
        },
    },
    methods: {
        async openAddressPopup() {
            const addrId = this.employee?.Employee?.AddressId;
            if (!addrId) {
                this.resetAddressForm();
                this.popupAdreseVisible = true;
                return;
            }
            try {
                const store: any = this.dsAdrese.store();
                const adresa = await store.byKey(addrId);

                if (!adresa) {
                    this.resetAddressForm();
                    this.popupAdreseVisible = true;
                    return;
                }
                this.dataAdress = {
                    LocalitateID: adresa.LocalitateID ?? null,
                    JudetID: adresa.JudetID ?? null,
                    Telefon: adresa.Telefon ?? null,
                    Email: adresa.Email ?? null,
                    TaraID: adresa.TaraID ?? null,
                    LocalitateCodSiruta: adresa.LocalitateCodSiruta ?? null,
                    TipCod: adresa.TipCod ?? null,
                    Strada: adresa.Strada ?? '',
                    StradaNr: adresa.StradaNr ?? '',
                    Bloc: adresa.Bloc ?? '',
                    Scara: adresa.Scara ?? '',
                    Etaj: adresa.Etaj ?? '',
                    Apartament: adresa.Apartament ?? '',
                    CodPostal: adresa.CodPostal ?? '',
                    PartenerID: null,
                    EmailPersonal: adresa.EmailPersonal ?? null,
                    TelefonPersonal: adresa.TelefonPersonal ?? null
                };

                this.taraId = adresa.TaraID ?? null;
                this.judetId = adresa.JudetID ?? null;
                this.localitateId = adresa.LocalitateID ?? null;
                this.codSiruta = adresa.LocalitateCodSiruta ?? null;
                this.satId = adresa.LocalitateCodSiruta ?? null;

                if (this.taraId) {
                    this.dsJudete.filter(["TaraID", "=", this.taraId]);
                    await this.dsJudete.load();
                }
                if (this.judetId) {
                    this.dsLocalitati.filter(["JudetID", "=", this.judetId]);
                    await this.dsLocalitati.load();

                    const items = this.dsLocalitati.items ? this.dsLocalitati.items() : [];
                    if (this.codSiruta && items?.length) {
                        const satRow = items.find((x: any) => x.CodSiruta === this.codSiruta);
                        if (satRow) {
                            this.satId = satRow.ID;
                        }
                    }
                }
                
            } catch (err) {
                console.error("Eroare la încărcarea adresei:", err);
                this.resetAddressForm();
            }
            this.popupAdreseVisible = true;
        },

        resetAddressForm() {
            this.dataAdress = {
                LocalitateID: null,
                JudetID: null,
                Telefon: null,
                Email: null,
                TaraID: null,
                LocalitateCodSiruta: null,
                TipCod: null,
                Strada: '',
                StradaNr: '',
                Bloc: '',
                Scara: '',
                Etaj: '',
                Apartament: '',
                CodPostal: '',
                PartenerID: null,
                EmailPersonal: null,
                TelefonPersonal: null
            };
            this.taraId = null;
            this.judetId = null;
            this.localitateId = null;
            this.satId = null;
            this.codSiruta = null;
        },
        applyAddress() {
            const a = this.dataAdress;

            const adresa1 = [
                a.Strada ? `Str. ${a.Strada}` : null,
                a.StradaNr ? `${a.StradaNr}` : null,
                a.Bloc ? `Bl. ${a.Bloc}` : null,
                a.Scara ? `Sc. ${a.Scara}` : null,
                a.Etaj ? `Et. ${a.Etaj}` : null,
                a.Apartament ? `Ap. ${a.Apartament}` : null,
                a.CodPostal ? `CP ${a.CodPostal}` : null
            ]
                .filter(x => x !== null)
                .join(', ');

            const body = {
                ...a,
                Adresa1: adresa1,
                Adresa2: null
            };

            PER_Employees.saveAdrese(body)
                .then((response) => {
                    const saved = response?.data ?? response;

                    const newId = saved.id || saved.ID;

                    if (!newId) {
                        console.error('Nu am primit ID-ul noii adrese din API.', saved);
                    }

                    this.popupAdreseVisible = false;

                    if (this.dsAdrese && typeof this.dsAdrese.reload === 'function') {
                        this.dsAdrese.reload().then(() => {
                            this.employee.Employee.AddressId = newId;
                        });
                    } else if (this.dsAdrese && typeof this.dsAdrese.load === 'function') {
                        this.dsAdrese.load().then(() => {
                            this.employee.Employee.AddressId = newId;
                        });
                    } else {
                        this.employee.Employee.AddressId = newId;
                    }

                    notify('Adresa a fost salvată cu succes.', 'success', 3000);
                })
                .catch((error) => {
                    let msg = 'A apărut o eroare la salvare.';
                    if (error.response && error.response.data) {
                        msg = error.response.data.message
                            || error.response.data.error
                            || msg;
                    } else if (error.message) {
                        msg = error.message;
                    }
                    notify(msg, 'error', 4000);
                    console.error(error);
                });
        },
        onCnpChanged(e: any) {
            const cnp = e.value as string;
            const emp = this.employee.Employee;

            emp.Cnp = cnp;

            if (!cnp || cnp.length < 13) {
                this.isCnpValid = false;
                emp.Sex = null;
                emp.BornDate = null;
                emp.DepartmentId = null;
                return;
            }

            const valid = this.isValidCnp(cnp);
            this.isCnpValid = valid;

            if (!valid) {
                notify("CNP introdus este incorect.", "error", 3000);

                emp.Sex = null;
                emp.BornDate = null;
                emp.DepartmentId = null;

                return;
            }

            const s = parseInt(cnp[0], 10);
            const yy = cnp.substring(1, 3);
            const mm = cnp.substring(3, 5);
            const dd = cnp.substring(5, 7);

            let yearPrefix = "";
            if (s === 1 || s === 2) yearPrefix = "19";
            else if (s === 3 || s === 4) yearPrefix = "18";
            else if (s === 5 || s === 6) yearPrefix = "20";
            else if (s === 7 || s === 8) yearPrefix = "20";

            const fullYear = parseInt(yearPrefix + yy, 10);
            const birthDate = new Date(fullYear, parseInt(mm, 10) - 1, parseInt(dd, 10), 12, 0, 0);
            emp.BornDate = birthDate;


            const sexValue = (s % 2 === 1) ? "M" : "F";

            emp.Sex = sexValue;

        },

        isValidCnp(cnp: string): boolean {
            if (!cnp || cnp.length !== 13) return false;
            if (!/^\d{13}$/.test(cnp)) return false;

            const s = parseInt(cnp[0], 10);
            if (s < 1 || s > 8) return false;

            const yy = parseInt(cnp.substring(1, 3), 10);
            const mm = parseInt(cnp.substring(3, 5), 10);
            const dd = parseInt(cnp.substring(5, 7), 10);

            let yearPrefix = "";
            if (s === 1 || s === 2) yearPrefix = "19";
            else if (s === 3 || s === 4) yearPrefix = "18";
            else if (s === 5 || s === 6) yearPrefix = "20";
            else if (s === 7 || s === 8) yearPrefix = "20";

            const fullYear = parseInt(yearPrefix + yy.toString().padStart(2, "0"), 10);

            const birthDate = new Date(fullYear, mm - 1, dd);

            if (
                birthDate.getFullYear() !== fullYear ||
                birthDate.getMonth() !== mm - 1 ||
                birthDate.getDate() !== dd
            ) {
                return false;
            }

            const today = new Date();
            if (birthDate > today) return false;

            const weights = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
            let sum = 0;

            for (let i = 0; i < 12; i++) {
                sum += parseInt(cnp[i], 10) * weights[i];
            }

            let control = sum % 11;
            if (control === 10) control = 1;

            const lastDigit = parseInt(cnp[12], 10);

            return control === lastDigit;
        },
        getAll() {
            PER_Employees.getAll()
                .then((response: any) => {
                    this.dsGetAll = {
                        ...this.dsGetAll,
                        ...response.data
                    };
                })
                .catch((e: Error) => console.log(e));
        },
        async getAngajatiByID(id: string) {
            const { data } = await PER_Employees.getByID(id);
            const raw = Array.isArray(data)
                ? (data[0] ?? {})
                : (data?.value ? (data.value[0] ?? {}) : data ?? {});

            const row: any = {};
            for (const k in raw) row[k] = raw[k];

            Object.assign(this.employee, row);
        },
        onEditIdentClick() {
            if (!this.isEditing) {
                this.employeeOriginalIdent = JSON.parse(JSON.stringify(this.employee));
                this.isEditing = true;
                return;
            }
            this.isEditing = false;
            this.employeeOriginalIdent = null;
        },
        onCancelIdent() {
            if (this.employeeOriginalIdent) {

                Object.assign(this.employee, this.employeeOriginalIdent);
            }
            this.isEditing = false;
            this.employeeOriginalIdent = null;
        },
        getDepartamente() {
            PER_ActiveEmployees
                .getDepartamente()
                .then((response: any) => {
                    this.dsStructuri = response.data;
                })
                .catch((e: Error) => console.log(e));
        },
        getLookup(employeeId: string) {
            PER_ActiveEmployees
                .getLookup(employeeId)
                .then((response: any) => {
                    this.employee = response.data;
                })
                .catch((e: Error) => console.log(e));
        },
        openEdit() {
            this.editModel = JSON.parse(JSON.stringify(this.employee));
            this.errorText = "";
            this.popupVisible = true;
        },

        submitForm() {
            if (this.isSaving) return;

            const form = this.$refs.editFormRef.instance;
            const result = form.validate();

            if (!result.isValid) {
                return;
            }

            this.isSaving = true;

            const id = this.employee.Employee.Id;   // sau cum îl ai în obiect
            const dto = this.employee.Employee;

            PER_Employees.update(id, dto)
                .then(() => {
                    this.$emit("saved");
                    this.popupVisible = false;
                })
                .catch(err => {
                    console.error("Eroare salvare:", err);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },

        closePopup(): void {
            this.popupVisible = false;
        },
        closePopupAdrese(): void {
            this.popupAdreseVisible = false;
        },
        onTaraChanged(e) {
            this.taraId = e.value;
            this.dataAdress.TaraID = e.value;
            this.judetId = null;
            this.localitateId = null;
            this.satId = null;
            this.codSiruta = null;

            this.dsJudete.filter(["TaraID", "=", this.taraId]);
            this.dsJudete.load();
        },
        onJudetChanged(e) {
            this.judetId = e.value;
            this.dataAdress.JudetID = e.value;
            this.localitateId = null;
            this.satId = null;
            this.codSiruta = null;

            this.dsLocalitati.filter(["JudetID", "=", this.judetId]);
            this.dsLocalitati.load();
        },
        onLocalitateChanged(e) {
            this.localitateId = e.value;
            this.dataAdress.LocalitateID = e.value;
            this.satId = null;

            this.dsLocalitati.filter(["JudetID", "=", this.judetId]);
            this.dsLocalitati.load();
        },
        onSatChanged(e) {
            this.satId = e.value;

            if (!e.value || !this.dsLocalitati) return;

            const items = this.dsLocalitati.items ? this.dsLocalitati.items() : [];

            const satRow = items.find(x => x.ID === e.value);
            if (satRow) {
                this.codSiruta = satRow.CodSiruta;
                this.dataAdress.LocalitateCodSiruta = satRow.CodSiruta;
            }
        }
    }

})
</script>

<style scoped>
:deep(.tabs-two-rows .dx-tabs-wrapper) {
    flex-wrap: wrap;
}


:deep(.tabs-two-rows .dx-tab:nth-child(9)) {
    flex-basis: 25%;
    max-width: 25%;
}

:deep(.tabs-two-rows .dx-tab:nth-child(10)) {
    flex-basis: 30%;
    max-width: 30%;
}

:deep(.tabs-two-rows .dx-tab:nth-child(11)) {
    flex-basis: 50%;
    max-width: 50%;
}

:deep(.tabs-two-rows .dx-tab.dx-tab-selected) {
    background-color: #ff2c21;
    color: #ffffff;
}

:deep(.tabs-two-rows .dx-tab.dx-tab-selected .dx-tab-text) {
    color: inherit;
}

.edit-icon-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 34px;
    height: 34px;
    background: transparent;
    border: none;
    padding: 0;
    border-radius: 50%;
    cursor: pointer;
    background-image: url("data:image/svg+xml;utf8,<svg width='20' height='20' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fill='%23ff6a00' d='M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25zM20.71 7.04c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2.34-2.34c-.18-.18-.43-.29-.71-.29-.28 0-.53.11-.71.29l-1.83 1.83 3.75 3.75 1.83-1.83z'/></svg>");
    background-size: 20px 20px;
    /* Micșorare icon */
    background-repeat: no-repeat;
    background-position: center;
}

.edit-icon-btn:hover {
    background-color: rgba(255, 106, 0, 0.08);
}


/* card */
.emp-card {
    background: var(--dx-color-bg, #fff);
    border: 1px solid rgba(0, 0, 0, .08);
    box-shadow: 0 6px 18px rgba(0, 0, 0, .06);
    padding: 20px 16px 8px;
}

.emp-card__header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
}

.emp-card__subtitle {
    opacity: .75;
    font-size: .95rem;
}

/* scroll container */
.emp-form-wrapper {
    max-height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    scroll-behavior: smooth;
    scrollbar-width: thin;
}

.emp-form-wrapper::-webkit-scrollbar {
    width: 6px;
}

.emp-form-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, .25);

}

/* ACCORDEON */
.emp-acc :deep(.dx-accordion-item) {
    border: 1px solid rgba(0, 0, 0, .06);
    /* border-radius: 12px; */
    margin-bottom: 10px;
    overflow: hidden;
    background: #fff;
}

.emp-acc :deep(.dx-accordion-item-opened) {
    box-shadow: 0 8px 24px rgba(0, 0, 0, .06);
    border-color: rgba(0, 0, 0, .08);
}

.emp-acc__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    font-weight: 600;
    font-size: .95rem;
}

.emp-acc__title-text {
    opacity: .85;
}

.emp-acc__chev {
    width: 10px;
    height: 10px;
    position: relative;
}

/* panel interior */
.emp-acc__panel {
    padding: 10px 12px 14px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.015), transparent);
}

/* form styling fin */
.emp-form :deep(.dx-field-item-label-text) {
    font-size: .86rem;
    opacity: .8;
}

.emp-form :deep(.dx-texteditor),
.emp-form :deep(.dx-datebox) {
    margin-top: 4px;
}

.form-actions-right {
    display: flex;
    justify-content: flex-end;
}

.ml-2 {
    margin-left: 0.5rem;
}
</style>
